import { type CSSProperties } from 'react';
import { clsx } from 'clsx';
import { spinnerBase } from './spinner.css';

export interface SpinnerProps {
  /** Diameter in pixels (default: 40) */
  size?: number;
  /** CSS color override for the spinning arc */
  color?: string;
  className?: string;
  style?: CSSProperties;
}

export function Spinner({ size = 40, color, className, style }: SpinnerProps) {
  // Accept either a complete CSS color expression (e.g. `var(--abc)`, `#fff`,
  // `inherit`) or a bare CSS custom property name (e.g. `--abc`). Wrap bare
  // names with `var(...)` so the browser resolves them — passing a bare
  // `--abc` to `borderTopColor` is invalid CSS and silently dropped.
  const resolvedColor =
    typeof color === 'string' && color.startsWith('--') ? `var(${color})` : color;
  return (
    <span
      role="progressbar"
      aria-label="Loading"
      className={clsx(spinnerBase, className)}
      style={{ width: size, height: size, borderTopColor: resolvedColor, ...style }}
    />
  );
}
